import { useMutation, useQueryClient } from "@tanstack/react-query";
import {  post } from "@utils/axios_api";
import { qk } from "@utils/queryKey";


export function useLectureInvoiceModal(lectureId) {
  const queryClient = useQueryClient();

  const insertMut = useMutation(
    (payload) => post("/admin/lectureInvoice/insertInvoice", 
      { lectureId, ...payload,}),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(qk.invoiceList(lectureId));
      },
    }
  );

  const updateMut = useMutation(
    (payload) => post("/admin/lectureInvoice/updateInvoice", payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(qk.invoiceList(lectureId));
      },
    }
  );
  



  


  return {
    insertMut, updateMut
  };
}
